// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_hf","advertDetailHeaderPrice__value":"c-k_hg","advertDetailHeaderPrice__label":"c-k_hh"};